export enum ChatMessageName {
    Loading = 'loading'
}